module.exports = __webpack_public_path__ + "img/w3_exclamation_light.88e41449.png";